import React from 'react'
import Row1 from './Row1'
import Row2 from './Row2'
import Row3 from './Row3'
import Slider from './Slider'
import * as styles from './LogoCarousel.module.scss'

const LogoCarousel: React.FC = () => {
  return (
    <div className={styles.carousel}>
      <Slider>
        <Row1 />
      </Slider>
      <Slider count={9}>
        <Row2 />
      </Slider>
      <Slider>
        <Row3 />
      </Slider>
      <div className={styles.overlay} />
    </div>
  )
}

export default LogoCarousel
